import {call, put} from 'redux-saga/effects';
import BillingActions from '../redux/BillingRedux';
import MessagesActions from '../redux/MessagesRedux';

export function * getBilling(api, action) {
  const response = yield call(api.getBilling, {...action.props});

  if (response.ok) {
    yield put(BillingActions.billingSuccess({totalPages: response.data.totalPages, data: transformData(response.data.data), ...action.props}));
  } else {
    yield put(BillingActions.billingFailure(response.data && response.data.title ? response.data.title : response.problem));
    yield put(MessagesActions.messagesShow({type: 'error', code: response.status, title: response.data && response.data.title ? response.data.title : response.problem}));
  }
}

const transformData = data => {
  let dt = [];
  data.map(client => {
    if (client.cars && client.cars.length > 0) {
      client.cars.map((car, index) => dt.push({
        id: `${client.id}${index > 0 ? '#' + car.id : ''}`,
        rowSpan: index === 0 ? client.cars.length : 1,
        fullName: index > 0 ? "" : client.fullName,
        car: {...car}
      }))
    } else {
      dt.push({
        ...client
      })
    }
  })
  return dt;
}

export function* downloadBilling(api, action) {
  const response = yield call(
    api.getDownloadUrlXlsBilling,
    {...action.props}
  );

  if (response.ok) {
    const downloadUrl = window.URL.createObjectURL(
      new Blob(
        [response.data],
        {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}
      )
    );

    const link = document.createElement('a');
    link.href = downloadUrl;

    link.setAttribute('download', `billing_${Date.now()}.xlsx`);
    document.body.appendChild(link);
    link.click();
    link.remove();

    window.URL.revokeObjectURL(downloadUrl);

    yield put(BillingActions.billingDownloadSuccess());
  } else {
    yield put(BillingActions.billingDownloadFailure(
      response.data && response.data.title
        ? response.data.title
        : response.problem
    ));
    yield put(MessagesActions.messagesShow({
      type: 'error',
      code: response.status,
      title: response.data && response.data.title
        ? response.data.title
        : response.problem
    }));
  }
}